function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagDK(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExUReQXP+0iSvj4+P39/fPz8/zdrLoAAADeSURBVDjL7Y7REYQgDESTDkIHSmjgsAGGof+aLgmKyHn6cffpwqCEl92A27SIXm4UwQMMQFyYrx34LiLG+FsE+xhn/ARolfOReXZIDnVR3dQ5eNEsVSewnOiM7ByYq4MiugzC0WFLdthm8Lui/9QEfZlPgWv9DwitkmUHq8gnCxBUcg+5Sgm/EsJOkM1gc9A+bVBUzyAR1uZrLZ/M0FRKzt21CVeBmiccBQeHcuYABAgkqA6XyP73frIQ2+JQSoLvInnPSfoPAzYDrDOkWkA7qQZ0Q3YRdJJxN8MDXANvzLhwzpN8GhYAAAAASUVORK5CYII=",
    alt: "DK"
  }, props));
}